// Sesión: decidir si un 401 «SESION_EXPULSADA» debe cerrar la sesión de ESTE navegador.
//
// INCIDENTE 12-sep-2026 (Ann): «me echa cada 5 minutos, incluso trabajando». Causa real:
// una pestaña VIEJA del mismo navegador seguía preguntando cada 30 s (campana) con un
// token ya invalidado. Su 401 borraba el token COMPARTIDO de localStorage y tumbaba la
// pestaña buena; al volver a entrar, la pestaña vieja repetía el golpe → bucle.
//
// Regla: solo se cierra la sesión si el 401 corresponde al token que hay guardado AHORA.
// El blindaje F1 NO se afloja: si el token vigente es el expulsado, se cierra igual.
export const tokenDePeticion = (config) => {
  const cabecera = (config && config.headers && (config.headers.Authorization || config.headers.authorization)) || '';
  return String(cabecera).replace(/^Bearer\s+/i, '').trim();
};

export function debeCerrarPorExpulsion(tokenUsado, tokenGuardado) {
  if (!tokenGuardado) return false;             // ya no hay sesión que cerrar
  if (!tokenUsado) return true;                 // sin dato: comportamiento de antes (cerrar)
  return tokenUsado === tokenGuardado;          // solo si el rechazado es el vigente
}
